<template>
  <div class="ship-container">
    <div>
      <div class="ship-box">
        <img src="../assets/images/ship_map.png" style="z-index: -1;"> 
        <svg viewBox="0 0 3200 2400">       
          <g class="shape" @mouseout="hover(null)" @mouseover="hover(0)">
            <polygon class="shape-hidden" @click="select(0)" :class="{ 'selected': shipArea === 0 }" points="336.08 1464.6263 820.1119 1593.7173 876.0342 1890.6055 615.7273 1851.5138 488.0857 1905.0531 285.9747 1538.7466 336.08 1464.6263" fill="none"/>
            <path class="shape-visible" @click="select(0)" :class="{ 'selected': shipArea === 0,'hovered': shipHover === 0 }" d="m839.6,1869.4c-3.4-.1-7.1-.7-10.4-1.1-101.4-14.2-202-32.3-302.9-49.6-8.7-1.5-14.7-5.9-18-14-32.8-80.3-87.7-148.5-126.6-225.6-4.5-9-8.3-18.2-11.1-27.8-2.9-9.8,1.3-14.5,11.3-11.8,131.8,35.6,262.8,74,396.3,102.7,18.3,3.9,34.1,3.7,38.1,24.6,9.2,48.3,18.5,96.6,27.9,144.9,2.9,14.9,8.1,30.4,8.1,45.6.6002,10.2001-5.3998,12.3-12.6999,12.1001Z"/>
          </g>
          <g class="shape" @mouseout="hover(null)" @mouseover="hover(1)">
            <polygon class="shape-hidden" @click="select(1)" :class="{ 'selected': shipArea === 1 }" points="820.1119 1593.7173 876.0342 1890.6055 1063.2679 1915.4771 1225.1997 1928.9111 1205.4224 1660.1497 820.1119 1593.7173" fill="none"/>
            <path class="shape-visible" @click="select(1)" :class="{ 'selected': shipArea === 1,'hovered': shipHover === 1 }" d="m1206.4,1896c.3,12.3-2.3,15.2-15.2,14.1-95-7.8-189.1-22.4-283.9-31.3-11.1-1-16.5-8-18.7-17.9-13.2-59.2-23.1-120.4-35.2-180.4-3.9-19.3,5.3-22.3,19.6-19.4,100.3,20.1,201.3,35.3,302.2,52,12.8,2.1,15.9,6.2,17.1,19.3,4.8,54.5001,9.9,109.0001,14.1001,163.6001Z"/>
          </g>
          <g class="shape" @mouseout="hover(null)" @mouseover="hover(2)">
            <polygon class="shape-hidden" @click="select(2)" :class="{ 'selected': shipArea === 2 }" points="1205.4224 1660.1497 1225.1997 1928.9111 1567.8278 1950.6356 1875.9348 1953.6356 1940.9622 1703.671 1826.8225 1518.2408 1573.1923 1436.8466 1321.3146 1488.0251 1205.4224 1660.1497" fill="none"/>
            <path class="shape-visible" @click="select(2)" :class="{ 'selected': shipArea === 2,'hovered': shipHover === 2 }" d="m1787,1938.4c-128.1-.4-256.6-4.5-384.4-12.5-46.5-2.9-93-6.4-139.5-9.8-19.8-1.4-21.6-3.5-23.5-23.3-.8-8.3-3.9-46.5-4.8-54.8-1.2-11.3,3.5-15.9,15-15.1,40.2,2.8,191.1618,14.2374,315.6126,19.4654s261.9875,6.8345,302.9875,7.3345c15.5.2,17.9,3.1,14.4,17.9-1.9,8.1-12.7,46.2-14.7,54.3-3.1,12.7-6.9,15.8-20.2,16-20.2002.4001-40.5001.5001-60.9001.5001Z"/>
          </g>
          <g class="shape" @mouseout="hover(null)" @mouseover="hover(3)">
            <polygon class="shape-hidden" @click="select(3)" :class="{ 'selected': shipArea === 3 }" points="1101.8676 2222.7322 2016.327 2222.7322 2159.0891 2176.0166 2311.7029 2005.4733 2206.655 1941.4452 1875.9348 1953.6356 1567.8278 1950.6356 1225.1997 1928.9111 1063.2679 1915.4771 1101.8676 2222.7322" fill="none"/>
            <path class="shape-visible" @click="select(3)" :class="{ 'selected': shipArea === 3,'hovered': shipHover === 3 }" d="m1528.3,2156.7h-375.9c-7,0-14,.1001-21-.1001-13.5-.3999-20.4-6-22.6-19.3-2.1-12.8-3.5-25.7-5.1-38.6001-3.2-25.7-6.4-51.5-9.6-77.2-3-24.4-8.7-49.9-8.6-74.5,0-9.3,4-13.5,13.5-13.2,10,.4,19.9,1.6,29.8,2.6,55.7,5.3,112.8,10.5,169.1,14.8,137.7,10.5,275.8,15.2,413.8,17.9,124.6,2.4,249.5.1,373.8999-5.8,24.3999-1.1,48.8-2.6,73.2-4.1,11.8999-.7,39.3-6.5,32.7,14.3-24.6001,77.2001-72,151.9-155.3,171.6-68.8,16.2-142.9,11.3999-213.1,11.3999h-294.9c.1001.0002.1001.1003.1001.2002Z"/>
          </g>
         
          <g class="shape" @mouseout="hover(null)" @mouseover="hover(4)">
            <polygon class="shape-hidden" @click="select(4)" :class="{ 'selected': shipArea === 4 }" points="876.0342 1890.6055 1063.2679 1915.4771 1101.8676 2222.7322 820.1119 2201.8921 648.9259 2128.9993 488.0857 1905.0531 615.7273 1851.5138 876.0342 1890.6055" fill="none"/>
            <path class="shape-visible" @click="select(4)" :class="{ 'selected': shipArea === 4,'hovered': shipHover === 4 }" d="m1033.5,2154.5c-33.7-1.7-70.6-3.7-107.4-7.5-39.9-4-79.2-10.5-118-20.6001-42.4-11.1001-87.1-31-113.9-67.8-15.2-21-24-47.4-32.8-71.5-10.4-28.5-19.3-57.5-29.3-86.2-4.2-12-9.1-31.5,11.2-28.5,128.2,19.2,256.1,38.9,384.9,53.4,17.8,2,21.5,10.3,22.9,21.8,7.1,58.8,15,117.6,22.4,176.4.6,5,1.1,9.8999,1.3,14.8999.4,9.8-4.2,14.8999-14.1,15.3999-7.9.5002-16.0001.2002-27.2001.2002Z"/>
          </g>
          <g class="shape" @mouseout="hover(null)" @mouseover="hover(5)">
            <polygon class="shape-hidden" @click="select(5)" :class="{ 'selected': shipArea === 5 }" points="1875.9348 1953.6356 1940.9622 1703.671 2364.2634 1675.8895 2403.5347 1721.9003 2311.7029 2005.4733 2206.655 1941.4452 1875.9348 1953.6356" fill="none"/>
            <path class="shape-visible" @click="select(5)" :class="{ 'selected': shipArea === 5,'hovered': shipHover === 5 }" d="m1937.7,1936.8c-9,0-18-.1-27-.4-11-.4-14.4-4.7-11.5-15.4,13.5-50.2,26.9-100.4,41.4-150.3,3.5-12.1,6.4-13.9,18.9-15.3,12-1.3,23.9-1.2,35.9-1.6,94.9-3.5,190.9999-8.3,286.2001-15.5,11.3-.9,22.6001-2,33.8999-2.5,13.3999-.6,17.1001,4.3,12.8,17.1-16.8999,49.8-34.1001,99.6-51.3,149.3-4,11.4-12.3999,17-24,18.1-57,5.2-114.3,8.3-171.5,10.6-47.7,1.8-95.9,5.8-143.8,5.9001Z"/>
          </g>
        </svg>
      </div>
      <div style="margin: 1em 1em 0 0;">
        <h2 :class="'room-text '+textHovered">{{ roomText }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShipMap",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    roomText() {
      if (this.shipHoverData && this.shipHoverData.name) {
        return this.shipHoverData.name
      } else {
        return this.currentArea.name
      }
    },
    textHovered() {
      if (this.roomText == this.currentArea.name) {
        return "currentText"
      } else {
        return ""
      }
    },
    shipArea() {
      return this.$store.getters.getShipArea
    },
    shipHoverData() {
      return this.$store.getters.getShipHover
    },
    shipHover() {
      if (this.shipHoverData) {
        return this.shipHoverData.zone
      } else {
        return null
      }
    },
    shipAreas() {
      return this.$store.getters.getShipAreas
    },
    currentArea() {
      return this.shipAreas[this.shipArea]
    }
  },
  mounted() { },
  methods: {
    select(area) {
      this.$store.commit('setShipArea', area)
    },
    hover(area) {
      this.$store.commit('setShipHoverArea', area)
    },
  }
};
</script>

<style scoped>
.ship-container {
  pointer-events: auto;
  display: flex;
  align-items: end;
}
.ship-box {
  pointer-events: auto;
  width: 16em;
  height: 12em;
  text-align: left;
  position: relative;
}
img {
  width: 16em;
  height: 12em;
  position: absolute;
}
path {
  fill: var(--light-blue);
  transition: 0.25s;
}
.shape:hover .shape-visible {
  fill: var(--white);
}
.shape .shape-hidden {
  fill: transparent;
}
.selected {
  fill: var(--orange);
  animation: pulse alternate 2s ease-in-out infinite;
}
.hovered {
  fill: var(--white);
}
@keyframes pulse {
  0% { filter: brightness(100%); }
  100% { filter: brightness(115%); }
}
.room-text {
  display: flex;
  flex-direction: column-reverse;
  margin: -0.25em;
}
.currentText {
  color: var(--orange);
  animation: pulse alternate 2s ease-in-out infinite;
}
</style>